import React from "react";
import { ErrorMessage, useField, Field } from "formik";

const TextField = ({
  elementType,
  min,
  max,
  label,
  width,
  padding,
  marginTop,
  cardWidth,
  showLabel,
  border,
  as,
  ...props
}) => {
  let [field] = useField(props);

  return (
    <>
      <div className="custom-input">
        {showLabel === "false" ? null : (
          <label htmlFor={field.name} className="label">
            {label}
          </label>
        )}

        <Field
          autoComplete="off"
          {...field}
          {...props}
          min={min}
          max={max}
          as={as}
        />

        <ErrorMessage
          component="p"
          name={field.name}
          style={{
            fontSize: "11px",
            color: "red",
          }}
        />
      </div>
    </>
  );
};
export default TextField;
